module.exports = __webpack_public_path__ + "fa-solid-900.d824df7eb2e268626a2d.woff2";


//////////////////
// WEBPACK FOOTER
// F:/node/angular/complejidadesFrontend/~/@fortawesome/fontawesome-free/webfonts/fa-solid-900.woff2
// module id = ../../../../@fortawesome/fontawesome-free/webfonts/fa-solid-900.woff2
// module chunks = 2